import React from "react";
import apiOva from "../../config/http";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ListSubheader from "@mui/material/ListSubheader";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/Download";

export function PrevUploadedDocuments({ numeroTicket, numColumns = 3 }) {
  const [prevUploadedDocuments, setPrevUploadedDocuments] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const getPrevUploadedDocuments = async (numeroTicket) => {
      setIsLoading(true);
      try {
        const response = await apiOva.get(
          `crm/documentos/consultarDocumentosPorTicket?numeroTicket=${numeroTicket}`
        );
        setPrevUploadedDocuments(response.data.result);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    getPrevUploadedDocuments(numeroTicket);
  }, [numeroTicket]);

  if (isLoading) {
    return (
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width={"100%"}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <div>
        <p>Lo sentimos, hubo un error al cargar los documentos</p>
      </div>
    );
  }

  return (
    <ImageList sx={{ width: "100%", height: 300 }} cols={numColumns} gap={8}>
      {prevUploadedDocuments?.map((item) => {
        const uri = `data:${item.tipoMime};base64,${item.contenido}`;
        const isPdf = item.tipoMime === "application/pdf";
        return (
          <ImageListItem key={item.img}>
            {isPdf ? (
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                width={"100%"}
                height={"150px"}
              >
                <PictureAsPdfIcon fontSize="large" />
              </Box>
            ) : (
              <Box>
                <img
                  src={uri}
                  alt={item.nombreArchivo}
                  loading="lazy"
                  style={{ width: "100%", height: "150px", objectFit: "cover" }}
                />
              </Box>
            )}
            <ImageListItemBar
              title={item.nombreArchivo}
              actionIcon={
                isPdf ? (
                  <IconButton
                    style={{ marginRight: "8px" }}
                    sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                    aria-label={`info about ${item.title}`}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = uri;
                      link.download = item.nombreArchivo;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    <DownloadIcon />
                  </IconButton>
                ) : null
              }
            />
          </ImageListItem>
        );
      })}
    </ImageList>
  );
}
